import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { TrashBinIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const DeleteNotesButton: FC<Props> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <AppButton disabled={disabled} className={styles.root} onClick={onClick}>
      <TrashBinIcon className={styles.icon} />
      <p>{t("common.deleteSelected")}</p>
    </AppButton>
  );
};
